import { api } from '../../../shared/services/api/client';

export const listStaff = () => api.get('/merchant/staff');
export const inviteStaff = (email, roleIds = []) => api.post('/merchant/staff', { email, roleIds });
export const updateStaff = (staffId, data) => api.patch(`/merchant/staff/${staffId}`, data);
export const removeStaff = (staffId) => api.delete(`/merchant/staff/${staffId}`);
export const assignRole = (staffId, roleId) => api.post('/merchant/staff/assign-role', { staffId, roleId });
export const unassignRole = (staffId, roleId) => api.post('/merchant/staff/unassign-role', { staffId, roleId });

export const listRoles = () => api.get('/merchant/roles');
export const createRole = (name, permissionKeys = []) =>
    api.post('/merchant/roles', { name, permissionKeys });
export const updateRole = (roleId, data) => api.patch(`/merchant/roles/${roleId}`, data);
export const deleteRole = (roleId) => api.delete(`/merchant/roles/${roleId}`);
export const getPermissionKeys = () => api.get('/merchant/permission-keys');
